var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorExclamationPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 16.5C10.7367 16.5 11.3337 15.903 11.3337 15.1667C11.3337 14.4303 10.7367 13.8333 10.0003 13.8333C9.26395 13.8333 8.66699 14.4303 8.66699 15.1667C8.66699 15.903 9.26395 16.5 10.0003 16.5Z",
    fill: "#E51837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 4.5H11.3337V12.5H8.66699L8.66699 4.5Z",
    fill: "#E51837"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorExclamationPoint);
export default __webpack_public_path__ + "static/media/error_exclamation_point.f2322f34611d34f87f61962120efe09c.svg";
export { ForwardRef as ReactComponent };